<div class="label_properties">
  <small class="debug">{{me}}</small>
  <fa-icon style="font-size: 3em; color: red" [icon]="faHammer"></fa-icon>
  <br/>
  <br/>
  <br/>
  <mat-label style="font-size: 1.2em">component still under construction</mat-label>
  <br/>
  <br/>
  @if (dynamicsInitialized) {
    <div>
      <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
      </dynamic-form>
    </div>
  }
</div>


